import React from "react";
import { Link } from "react-router-dom";
import Logo from "../../images/logo2.webp";

import ins1 from "../../images/instragram/mug.webp";
import ins2 from "../../images/instragram/IMG_2.webp";
import ins3 from "../../images/instragram/knoweb-mug.webp";
import ins4 from "../../images/instragram/IMG_4.webp";
import ins6 from "../../images/instragram/IMG_1.webp";
import ins5 from "../../images/instragram/IMG_3.webp";

const Footer = (props) => {
  const ClickHandler = () => {
    window.scrollTo(10, 0);
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="wpo-site-footer">
      <div className="wpo-upper-footer">
        <div className="container">
          <div className="row">
            <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="widget about-widget">
                <div className="logo widget-title">
                  <Link onClick={ClickHandler} to="/">
                    <img src={Logo} alt="blog" />
                  </Link>
                </div>
                <p>
                  Helping brands grow with smart design, code, and digital
                  strategy. Let’s build something great together.
                </p>
                <ul className="social">
                  <li>
                    <a
                      href="https://www.facebook.com/knowebsolutions"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="ti-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/company/knowebsolutions"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="ti-linkedin"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://wa.me/94702493211"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fab fa-whatsapp"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/knowebsolutions"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="ti-instagram"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="widget wpo-service-link-widget">
                <div className="widget-title">
                  <h3>Contact </h3>
                </div>
                <div className="contact-ft">
                  <ul>
                    <li>
                      <i className="fi flaticon-location"></i> No.422, 4th floor, Sanvik plaza, Wakwella Road, Galle, Sri Lanka.
                    </li>
                    <li>
                      <i className="fi flaticon-phone-call"></i> (+94)70 24 93 211
                    </li>
                    <li>
                      <i className="fi flaticon-send"></i>{" "}
                      info@knowebsolutions.com
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="widget link-widget">
                <div className="widget-title">
                  <h3>Services </h3>
                </div>
                <ul>
                  <li>
                    <Link
                      onClick={ClickHandler}
                      to="/service-single/custom-software-development"
                    >
                      Software Solutions
                    </Link>
                  </li>
                  <li>
                    <Link
                      onClick={ClickHandler}
                      to="/service-single/web-application-development"
                    >
                      Web Application Development
                    </Link>
                  </li>
                  <li>
                    <Link
                      onClick={ClickHandler}
                      to="/service-single/iot-solutions"
                    >
                      IoT Solutions
                    </Link>
                  </li>
                  <li>
                    <Link
                      onClick={ClickHandler}
                      to="/service-single/it-consulting"
                    >
                      IT Consulting{" "}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>

            <div className="col col-lg-3 col-md-6 col-sm-12 col-12">
              <div className="widget instagram">
                <div className="widget-title">
                  <h3>Gallery</h3>
                </div>
                <ul className="d-flex">
                  <li>
                    <img src={ins1} alt="" />
                  </li>
                  <li>
                    <img src={ins2} alt="" />
                  </li>
                  <li>
                    <img src={ins3} alt="" />
                  </li>
                  <li>
                    <img src={ins4} alt="" />
                  </li>
                  <li>
                    <img src={ins5} alt="" />
                  </li>
                  <li>
                    <img src={ins6} alt="" />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="wpo-lower-footer">
        <div className="container">
          <div className="row">
            <div className="col col-xs-12">
              <p className="copyright">
                Copyright &copy; {currentYear} Knoweb PVT LTD. All Rights
                Reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
